import {initSplideSlider} from '../Plugin/SplideSlider';
import LazyLoad from "vanilla-lazyload";

const splideSliders = document.querySelectorAll('.splide');

if (splideSliders.length) {
    Array.from(splideSliders).forEach((splideSlider) => {
        const lazyLoad = new LazyLoad({
            container: splideSlider,
            elements_selector: '.img-fluid',
            threshold: 200
        });

        const splide = initSplideSlider(splideSlider);
        lazyLoad.update();

        splide.on('moved', () => {
            lazyLoad.update();
        });
    });
}
